import { useQuery } from '@tanstack/react-query';

import { contractHistoryQueryOptions } from '../data-provider';
import type { ContractHistoryParams } from '../models';

export const useContractHistory = (params: ContractHistoryParams) => useQuery(contractHistoryQueryOptions(params));
